/* The Butterfly Effect — count-up. Any element with [data-countup] animates the first number
   in its text from 0 up to its value when it scrolls into view, preserving the prefix, suffix,
   decimals, and comma grouping (e.g. "+1.8 Million", "30,000+", "1,840,000+"). Respects
   reduced motion (leaves the final value in place). Runs once per element. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function group(intStr) { return intStr.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function fmt(n, dec, grouped) {
    var s = n.toFixed(dec);
    if (grouped) { var p = s.split('.'); p[0] = group(p[0]); s = p.join('.'); }
    return s;
  }
  function easeOutCubic(t) { return 1 - Math.pow(1 - t, 3); }

  function run(el) {
    var raw = el.getAttribute('data-countup-text') || el.textContent;
    var m = raw.match(/(\d[\d,]*(?:\.\d+)?)/);
    if (!m) return;
    el.setAttribute('data-countup-text', raw);
    var numStr = m[1];
    var prefix = raw.slice(0, m.index);
    var suffix = raw.slice(m.index + numStr.length);
    var grouped = numStr.indexOf(',') >= 0;
    var dec = (numStr.split('.')[1] || '').length;
    var target = parseFloat(numStr.replace(/,/g, ''));
    if (reduce || !isFinite(target)) {
      el.textContent = raw;
      return;
    }

    var dur = 1700, startTs = null;
    function tick(ts) {
      if (startTs === null) startTs = ts;
      var p = Math.min(1, (ts - startTs) / dur);
      el.textContent = prefix + fmt(target * easeOutCubic(p), dec, grouped) + suffix;
      if (p < 1) requestAnimationFrame(tick);
      else el.textContent = raw;
    }
    requestAnimationFrame(tick);
  }

  function init() {
    var els = [].slice.call(document.querySelectorAll('[data-countup]'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) return; // leave values as rendered
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
